import {
    GET_NEWS_FEEDS_SUCCESS,
    GET_NEWS_FEEDS_FAILURE,
    SEARCH_COUNTERPARTY_NAME_SUCCESS,
    SEARCH_COUNTERPARTY_NAME_FAILURE,
    SUBMIT_NEWS_FEED_SUCCESS,
    SUBMIT_NEWS_FEED_FAILURE
} from "./action";
// import analystsListReducer from "../../Admin/Analyst/List/reducer";
const initialState = {
    newsFeedsSuccess: {
        content: []
    },
    newsFeedsFailure: [],
    searchCounterpartyResults: [],
    searchCounterpartyResultsFailure: [],
    submitNewsFeedSuccess: [],
    submitNewsFeedFailure: []
}

const newsFeedsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NEWS_FEEDS_SUCCESS:
            return state = {
                ...state,
                newsFeedsSuccess: action.data
            }
        case GET_NEWS_FEEDS_FAILURE:
            return state = {
                ...state,
                newsFeedsFailure: action.data
            }
        case SEARCH_COUNTERPARTY_NAME_SUCCESS:
            return state = {
                ...state,
                searchCounterpartyResults: action.data
            }
        case SEARCH_COUNTERPARTY_NAME_FAILURE:
            return state = {
                ...state,
                searchCounterpartyResultsFailure: action.data
            }
        case SUBMIT_NEWS_FEED_SUCCESS:
            return state = {
                ...state,
                submitNewsFeedSuccess: action.data
            }
        case SUBMIT_NEWS_FEED_FAILURE:
            return state = {
                ...state,
                submitNewsFeedFailure: action.data
            }
        default: return state;
    }
}
export default newsFeedsReducer;
